import { Apple, Play, Clock } from "lucide-react";

const base =
  "group inline-flex items-center gap-3 rounded-full px-5 py-3 text-sm font-medium transition-[background-color,color,border-color,transform] duration-300 will-change-transform";

const Unavailable = ({ label, testId }) => (
  <span
    data-testid={testId}
    title="Link not published yet"
    className={`${base} cursor-not-allowed border text-gray-500`}
    style={{ borderColor: "var(--line)" }}
  >
    <Clock className="h-4 w-4" aria-hidden />
    {label}
  </span>
);

export const StoreButtons = ({ app, size = "md" }) => {
  const pad = size === "lg" ? "px-6 py-3.5 text-base" : "";
  const ios = app.platforms.includes("iOS");
  const android = app.platforms.includes("Android");

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`store-buttons-${app.slug}`}>
      {ios &&
        (app.appStoreUrl ? (
          <a
            data-testid={`app-detail-download-ios-${app.slug}`}
            href={app.appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`${base} ${pad} bg-white text-[#08090d] hover:-translate-y-0.5 hover:bg-[var(--accent-soft)]`}
          >
            <Apple className="h-4 w-4" aria-hidden />
            Download on the App Store
          </a>
        ) : (
          <Unavailable label="App Store — link coming" testId={`app-detail-ios-pending-${app.slug}`} />
        ))}
      {android &&
        (app.googlePlayUrl ? (
          <a
            data-testid={`app-detail-download-android-${app.slug}`}
            href={app.googlePlayUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`${base} ${pad} border text-white hover:-translate-y-0.5 hover:border-[var(--accent)]`}
            style={{ borderColor: "var(--line)" }}
          >
            <Play className="h-4 w-4" aria-hidden />
            Get it on Google Play
          </a>
        ) : (
          <Unavailable
            label="Google Play — link coming"
            testId={`app-detail-android-pending-${app.slug}`}
          />
        ))}
    </div>
  );
};
